import type { LanguagePreference } from '../../shared/types';

export const translations = {
  de: {
    appTitle: 'Vault Kosmos',
    nodes: 'Knoten',
    links: 'Links',
    files: 'Dateien',
    index: 'Index',
    live: 'Live',
    demoMode: 'Demo',
    connecting: 'Verbinden',
    offline: 'Offline',
    keyboard: 'Tastatur',
    language: 'DE',
    controlDeck: 'Steuerpult',
    searchPlaceholder: 'Datei, Pfad, Tag',
    view: 'Ansicht',
    overview: 'Übersicht',
    focus: 'Fokus',
    depth: 'Tiefe',
    fly: 'Flug',
    labels: 'Beschriftung',
    labelsOn: 'Beschriftung an',
    labelsOff: 'Beschriftung aus',
    liveFocus: 'Live-Fokus',
    currentChange: 'Aktuelle Anpassung',
    newFile: 'Neue Datei',
    clearFocus: 'Fokus lösen',
    relations: 'Beziehungen',
    vault: 'Vault',
    chooseVault: 'Vault auswählen...',
    chooseVaultBusy: 'Dialog...',
    vaultLaunchTitle: 'Explore your Vault',
    vaultLaunchSubtitle: 'Betritt den Knowledge Kosmos.',
    vaultLaunchCopy: 'Wähle lokal den Ordner deines Obsidian-Vaults. Vault Kosmos indexiert ihn auf diesem Gerät und startet danach die Live-Ansicht.',
    vaultLaunchImport: 'Vault importieren',
    vaultLaunchContinue: 'Aktuellen Vault betreten',
    vaultLaunchManualAction: 'Manuell eintragen',
    vaultLaunchManualHint: 'Du kannst den Pfad später im Steuerpult ändern.',
    vaultLaunchLocal: 'Lokale Verarbeitung',
    vaultLaunchLocalCopy: 'Dateien, Index und Watcher bleiben lokal in diesem Workspace.',
    vaultSelectorTitle: 'Vault verbinden',
    vaultSelectorCopy: 'Ordnerdialog öffnen oder den Pfad manuell setzen.',
    demoVaultTitle: 'Statischer Demo-Vault',
    demoVaultCopy: 'Diese GitHub-Pages-Version zeigt einen kuratierten Beispielkosmos ohne lokalen Connector.',
    manualPath: 'Manueller Pfad',
    pathPlaceholder: 'Pfad zum Obsidian-Vault',
    load: 'Laden',
    loading: 'Lädt',
    vaultChecking: 'Vault-Pfad wird geprüft',
    areas: 'Bereiche',
    filters: 'Filter',
    unresolved: 'Unresolved',
    inspector: 'Details',
    backlinks: 'Backlinks',
    noBacklinks: 'Keine Backlinks',
    calmView: 'Ruhige Ansicht',
    noFileSelected: 'Keine Datei ausgewählt',
    noHighlightCopy: 'Live-Ereignisse laufen weiter, aber der Kosmos hebt gerade nichts hervor.',
    map: 'Orientierung',
    timeline: 'Entwicklung',
    genesis: 'Aufbau',
    eventTour: 'Ereignisflug',
    pause: 'Pause',
    fullVault: 'voller Vault',
    notes: 'Notizen',
    speed: 'Tempo',
    focusZoomOn: 'Fokus-Zoom an',
    focusZoomOff: 'Fokus-Zoom aus',
    colorLive: 'Live-Fokus',
    colorBirth: 'Neue Notiz',
    colorLinks: 'Linklinien',
    colorProperty: 'Property',
    colorUnresolved: 'Unresolved',
    colorEdit: 'Bearbeitung',
    colorGenesis: 'Genesis',
    colorWiki: 'Wiki/MD',
    colorRelation: 'Relation',
    colorOpen: 'offen',
    kind: 'Art',
    area: 'Bereich',
    type: 'Typ',
    status: 'Status',
    degree: 'Grad',
    keyboardTitle: 'Tastaturbefehle',
    keyboardSubtitle: 'Aktuelle Steuerung als Tastenfeld. Aktive Tasten können hier geklickt werden.',
    keyboardViewControls: 'Ansichten',
    keyboardUtilityControls: 'Werkzeuge',
    keyboardFlightControls: 'Flugsteuerung',
    keyOverview: 'Übersicht',
    keyOverviewDesc: 'Zur Gesamtansicht fliegen',
    keyFocus: 'Fokus',
    keyFocusDesc: 'Ausgewählten oder Live-Knoten fokussieren',
    keyDepth: 'Tiefe',
    keyDepthDesc: 'Näher in den Kosmos eintauchen',
    keyFly: 'Flug',
    keyFlyDesc: 'Flugmodus starten oder verlassen',
    keyExitFly: 'Flug verlassen',
    keyClear: 'Fokus lösen',
    keyClearDesc: 'Auswahl und Hervorhebung ausblenden',
    keyLabels: 'Labels',
    keyLabelsDesc: 'Beschriftungen ein- oder ausblenden',
    keyForward: 'Vorwärts',
    keyBack: 'Rückwärts',
    keyLeft: 'Links',
    keyRight: 'Rechts',
    keyLook: 'Blick',
    keyUp: 'Hoch',
    keyDown: 'Runter',
    keySprint: 'Schneller',
    keySpaceDesc: 'Nach oben steigen',
    keyCtrlDesc: 'Nach unten sinken',
    keyHelp: 'Hilfe',
    keyHelpDesc: 'Tastaturübersicht öffnen',
    keyReserved: 'Frei',
    keyReservedDesc: 'Für spätere Befehle reserviert',
    close: 'Schließen',
    flightHint: 'Canvas anklicken, dann Mausblick. WASD fliegt, Pfeiltasten drehen, E/C hoch/runter, Shift schneller, F verlässt den Flugmodus.',
    indexBuilding: 'Index wird aufgebaut',
    vaultInvalid: 'Vault-Pfad ist ungültig.',
    dialogCancelled: 'Auswahl abgebrochen.',
    dialogFailed: 'Ordnerdialog konnte nicht geöffnet werden. Manueller Pfad bleibt verfügbar.'
  },
  en: {
    appTitle: 'Vault Kosmos',
    nodes: 'Nodes',
    links: 'Links',
    files: 'Files',
    index: 'Index',
    live: 'Live',
    demoMode: 'Demo',
    connecting: 'Connecting',
    offline: 'Offline',
    keyboard: 'Keyboard',
    language: 'EN',
    controlDeck: 'Control Deck',
    searchPlaceholder: 'File, path, tag',
    view: 'View',
    overview: 'Overview',
    focus: 'Focus',
    depth: 'Depth',
    fly: 'Fly',
    labels: 'Labels',
    labelsOn: 'Labels on',
    labelsOff: 'Labels off',
    liveFocus: 'Live Focus',
    currentChange: 'Current Change',
    newFile: 'New File',
    clearFocus: 'Clear Focus',
    relations: 'Relations',
    vault: 'Vault',
    chooseVault: 'Choose Vault...',
    chooseVaultBusy: 'Dialog...',
    vaultLaunchTitle: 'Explore your Vault',
    vaultLaunchSubtitle: 'Enter the knowledge kosmos.',
    vaultLaunchCopy: 'Choose the local folder of your Obsidian vault. Vault Kosmos indexes it on this device and starts the live view.',
    vaultLaunchImport: 'Import Vault',
    vaultLaunchContinue: 'Enter current vault',
    vaultLaunchManualAction: 'Enter manually',
    vaultLaunchManualHint: 'You can change the path later in the Control Deck.',
    vaultLaunchLocal: 'Local processing',
    vaultLaunchLocalCopy: 'Files, index and watcher stay local in this workspace.',
    vaultSelectorTitle: 'Connect Vault',
    vaultSelectorCopy: 'Open the folder dialog or set the path manually.',
    demoVaultTitle: 'Static demo vault',
    demoVaultCopy: 'This GitHub Pages version shows a curated sample cosmos without a local connector.',
    manualPath: 'Manual path',
    pathPlaceholder: 'Path to Obsidian vault',
    load: 'Load',
    loading: 'Loading',
    vaultChecking: 'Checking vault path',
    areas: 'Areas',
    filters: 'Filters',
    unresolved: 'Unresolved',
    inspector: 'Inspector',
    backlinks: 'Backlinks',
    noBacklinks: 'No backlinks',
    calmView: 'Calm View',
    noFileSelected: 'No file selected',
    noHighlightCopy: 'Live events continue, but the cosmos is not highlighting anything right now.',
    map: 'Map',
    timeline: 'Timeline',
    genesis: 'Genesis',
    eventTour: 'Event Tour',
    pause: 'Pause',
    fullVault: 'full vault',
    notes: 'notes',
    speed: 'Speed',
    focusZoomOn: 'Focus zoom on',
    focusZoomOff: 'Focus zoom off',
    colorLive: 'Live Focus',
    colorBirth: 'New Note',
    colorLinks: 'Link Lines',
    colorProperty: 'Property',
    colorUnresolved: 'Unresolved',
    colorEdit: 'Editing',
    colorGenesis: 'Genesis',
    colorWiki: 'Wiki/MD',
    colorRelation: 'Relation',
    colorOpen: 'open',
    kind: 'Kind',
    area: 'Area',
    type: 'Type',
    status: 'Status',
    degree: 'Degree',
    keyboardTitle: 'Keyboard Shortcuts',
    keyboardSubtitle: 'Current controls as a keyboard layout. Active keys can be clicked here.',
    keyboardViewControls: 'Views',
    keyboardUtilityControls: 'Tools',
    keyboardFlightControls: 'Flight Controls',
    keyOverview: 'Overview',
    keyOverviewDesc: 'Fly to the full vault view',
    keyFocus: 'Focus',
    keyFocusDesc: 'Focus the selected or live node',
    keyDepth: 'Depth',
    keyDepthDesc: 'Move deeper into the cosmos',
    keyFly: 'Fly',
    keyFlyDesc: 'Enter or leave flight mode',
    keyExitFly: 'Exit Fly',
    keyClear: 'Clear Focus',
    keyClearDesc: 'Hide selection and highlights',
    keyLabels: 'Labels',
    keyLabelsDesc: 'Toggle labels in the 3D space',
    keyForward: 'Forward',
    keyBack: 'Back',
    keyLeft: 'Left',
    keyRight: 'Right',
    keyLook: 'Look',
    keyUp: 'Up',
    keyDown: 'Down',
    keySprint: 'Faster',
    keySpaceDesc: 'Rise upward',
    keyCtrlDesc: 'Sink downward',
    keyHelp: 'Help',
    keyHelpDesc: 'Open keyboard overview',
    keyReserved: 'Free',
    keyReservedDesc: 'Reserved for future commands',
    close: 'Close',
    flightHint: 'Click the canvas for mouse look. WASD flies, arrow keys turn, E/C rise or sink, Shift is faster, F leaves flight mode.',
    indexBuilding: 'Building index',
    vaultInvalid: 'Vault path is invalid.',
    dialogCancelled: 'Selection cancelled.',
    dialogFailed: 'Folder dialog could not be opened. Manual path is still available.'
  }
} as const;

export type TranslationKey = keyof typeof translations.de;
export type Translate = (key: TranslationKey) => string;

export function createTranslator(language: LanguagePreference): Translate {
  return (key) => translations[language][key] ?? translations.de[key] ?? key;
}

export function detectLanguage(): LanguagePreference {
  return navigator.language.toLowerCase().startsWith('de') ? 'de' : 'en';
}
